import {PeopleIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasReviewRequests, pluralize} from './activity-row-helpers'

export function ReviewRequestsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasReviewRequests(summary)) return null

  const n = summary.reviewRequested.count
  const label = `${n} review request ${pluralize(n, 'change', 'changes')}`

  return <SidebarActivityRow icon={PeopleIcon} label={label} group="reviewRequests" expectedCount={n} />
}
